import React from 'react';
import "../CSS/SoftwareSkill.css";
import { skillsSection } from "../Portfolio";

export default function SoftwareSkill() {
    return (
        <div className="software-skills-main-div">
            <ul className="dev-icons">
                {skillsSection.softwareSkills.map((skills, i) => {
                    return (
                        <li key={i} className="software-skill-inline" name={skills.skillName}>
                            <i className={skills.fontAwesomeClassname}></i>
                            <p>{skills.skillName}</p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
